import React, { useEffect, useRef, useState } from "react";
import { TextField, Typography } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import AddIcon from "@mui/icons-material/Add";
import {
  addorganization,
  editorganization,
  addproject,
  editproject,
} from "../../Restclient/datacollection";
import { useSelector, useDispatch } from "react-redux";
import { setOrganizationtree } from "../../store/cofig_data";
import CustomToast from "../CommonComponents/CustomToast";

export default function AddOrganizationconf(props) {
  const dispatch = useDispatch();
  const organizationtree = useSelector(
    (state) => state.configdata.organizationdatatree,
  );

  const inputFile = useRef(null);
  const [backgroundimg, setBackgroundimg] = useState("");
  const [imageheight, setImageheight] = useState(100);
  const [imagewidth, setImagewidth] = useState(100);
  const [orgname, setOrgname] = useState("");
  const [place, setPlace] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [pincode, setPincode] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [weblink, setWeblink] = useState("");
  const [showmsg, setShowmsg] = useState(false);
  const [msg, setMsg] = useState("");
  const [msgcolor, setMsgcolor] = useState(false);

  const savedatacallback = (result) => {
    console.log("result ", result.data.treejson);
    dispatch(setOrganizationtree(result.data.treejson));
    setBackgroundimg("");
    setImageheight(100);
    setImagewidth(100);
    setOrgname("");
    setPlace("");
    setState("");
    setCountry("");
    setPincode("");
    setLatitude("");
    setLongitude("");
    setWeblink("");

    if (props.data.orgdata.type === "Organization") {
      setMsg("Organization Created");
    } else if (props.data.orgdata.type === "Project") {
      setMsg("Project Created");
    }

    setShowmsg(true);
    setMsgcolor(true);
  };

  const editdatacallbck = (result) => {
    console.log("data result ", result.data);
    if (result.status === "done") {
      if (props.data.orgdata.type === "Organization") {
        dispatch(setOrganizationtree(result.data.treejson));
        setMsg("Organization data updated");
        setShowmsg(true);
        setMsgcolor(true);
      } else if (props.data.orgdata.type === "Project") {
        dispatch(setOrganizationtree(result.data.treejson));
        setMsg("Project data updated");
        setShowmsg(true);
        setMsgcolor(true);
      }
    } else {
      if (props.data.orgdata.type === "Organization") {
        setMsg("Error in update Organization data");
        setShowmsg(true);
        setMsgcolor(false);
      } else if (props.data.orgdata.type === "Project") {
        setMsg("Error in update Project data");
        setShowmsg(true);
        setMsgcolor(false);
      }
    }
  };

  useEffect(() => {
    console.log("props.data ", props.data);
    if (props.data.request === "edit") {
      if (props.data.orgdata.type === "Organization") {
        if (organizationtree.hasOwnProperty("children")) {
          for (let i = 0; i < organizationtree.children.length; i++) {
            var orgdata = organizationtree.children[i].data;
            if (orgdata.Organizationname === props.data.orgdata.name) {
              setOrgname(orgdata.Organizationname);
              setPlace(orgdata.Oranizationdetails.Location);
              setState(orgdata.Oranizationdetails.State);
              setCountry(orgdata.Oranizationdetails.Country);
              setPincode(orgdata.Oranizationdetails.Pin);
              setWeblink(orgdata.Organizationlink);
              setLatitude(orgdata.Oranizationdetails.Latitude);
              setLongitude(orgdata.Oranizationdetails.Longitude);
              setBackgroundimg(orgdata.Logo.base64);
              setImageheight(orgdata.Logo.height);
              setImagewidth(orgdata.Logo.width);
            }
          }
        }
      } else if (props.data.orgdata.type === "Project") {
        console.log("props.data.orgdata ", props.data.orgdata);
        var proj = props.data.orgdata;
        setOrgname(proj.name);
        setPlace(proj.place);
        setState(proj.state);
        setCountry(proj.country);
        setPincode(proj.pin);
        setLatitude(proj.latitude);
        setLongitude(proj.longitude);
        setBackgroundimg(proj.logo);
        setImageheight(proj.logoheight);
        setImagewidth(proj.logowidth);
      }
    }
  }, [props.data.request]);

  useEffect(() => {
    //console.log("savetrigger ",props.savetrigger)
    console.log(
      "orgname ",
      orgname,
      props.data.request,
      props.data.orgdata.type,
      organizationtree,
    );
    if (props.savetrigger) {
      if (props.data.request === "add") {
        if (props.data.orgdata.type === "Organization") {
          if (orgname === "") {
            setMsg("Please provide Organization Name");
            setShowmsg(true);
            setMsgcolor(false);
            props.callbacksave();
            return;
          }

          if (organizationtree.hasOwnProperty("children")) {
            for (let i = 0; i < organizationtree.children.length; i++) {
              var orgdata = organizationtree.children[i].data;
              if (orgdata.Organizationname === orgname) {
                console.log(
                  "this name already exist ",
                  orgdata.Organizationname,
                );
                setMsg("This organization name already exist");
                setShowmsg(true);
                setMsgcolor(false);
                props.callbacksave();
                return;
              }
            }
          }

          var orgjson = {
            Organizationname: orgname,
            Oranizationdetails: {
              Location: place,
              State: state,
              Country: country,
              Latitude: latitude,
              Longitude: longitude,
              Pin: pincode,
            },
            Organizationlink: weblink,
            Logo: {
              base64: backgroundimg,
              height: imageheight,
              width: imagewidth,
            },
          };
          addorganization(orgjson, savedatacallback);
          props.callbacksave();
        } else if (props.data.orgdata.type === "Project") {
          if (orgname === "") {
            setMsg("Please provide Project Name");
            setShowmsg(true);
            setMsgcolor(false);
            props.callbacksave();
            return;
          }

          if (organizationtree.hasOwnProperty("children")) {
            for (let i = 0; i < organizationtree.children.length; i++) {
              var orgdata = organizationtree.children[i].data;
              if (orgdata.Organizationname === props.data.orgdata.orgname) {
                if (organizationtree.children[i].children.length) {
                  var childlist = organizationtree.children[i].children;
                  for (let j = 0; j < childlist.length; j++) {
                    if (childlist[j].data.Projectname === orgname) {
                      console.log(
                        "this name already exist ",
                        childlist[j].data.Projectname,
                      );
                      setMsg("This project name already exist");
                      setShowmsg(true);
                      setMsgcolor(false);
                      props.callbacksave();
                      return;
                    }
                  }
                } else {
                }
              }
            }
          }

          var orgjson = {
            Organizationname: props.data.orgdata.orgname,
            Projectname: orgname,
            Projectdetails: {
              Location: place,
              State: state,
              Region: "West Central",
              Country: country,
              Pin: pincode,
              Latitude: latitude,
              Longitude: longitude,
            },
            Logo: {
              base64: backgroundimg,
              height: imageheight,
              width: imagewidth,
            },
          };
          console.log("Adding project ", orgjson);
          addproject(orgjson, savedatacallback);
          props.callbacksave();
        }
      } else if (props.data.request === "edit") {
        if (props.data.orgdata.type === "Organization") {
          var orgjson = {
            Organizationname: orgname,
            Oranizationdetails: {
              Location: place,
              State: state,
              Country: country,
              Latitude: latitude,
              Longitude: longitude,
              Pin: pincode,
            },
            Organizationlink: weblink,
            Logo: {
              base64: backgroundimg,
              height: imageheight,
              width: imagewidth,
            },
          };
          editorganization(orgjson, editdatacallbck);
          props.callbacksave();
        } else if (props.data.orgdata.type === "Project") {
          console.log("project org ", props.data.orgdata);
          var orgjson = {
            Organizationname: props.data.orgdata.orgname,
            Projectname: orgname,
            Projectdetails: {
              Location: place,
              State: state,
              Region: "West Central",
              Country: country,
              Pin: pincode,
              Latitude: latitude,
              Longitude: longitude,
            },
            Logo: {
              base64: backgroundimg,
              height: imageheight,
              width: imagewidth,
            },
          };
          editproject(orgjson, editdatacallbck);
          props.callbacksave();
        }
      }
    }
  }, [props.savetrigger]);

  const handleaddlogoclick = () => {
    console.log("Add logo");
    inputFile.current.click();
    if (showmsg) {
      setShowmsg(false);
    }
  };

  const base64convert = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  };
  const handleimageUpload = (e) => {
    const { files } = e.target;

    if (files && files.length) {
      const file = files[0];
      const filename = file.name;
      const mimeType = file.type;

      var parts = filename.split(".");
      const fileType = parts[parts.length - 1];
      const isPngExtension = fileType.toLowerCase() === "png";
      const isPngMime = mimeType === "image/png" || mimeType === "image/x-png";

      if (!isPngExtension || !isPngMime) {
        alert("Invalid file type. Please upload a PNG image only.");
        e.target.value = "";
        return;
      }

      console.log("fileType", fileType, " file ", file);

      base64convert(file, (result) => {
        console.log("base64 ", result);
        setBackgroundimg(result);
      });
    }
  };

  const handlechangeheight = (e) => {
    setImageheight(e.target.value);
    if (showmsg) {
      setShowmsg(false);
    }
  };

  const handlechangewidth = (e) => {
    setImagewidth(e.target.value);
    if (showmsg) {
      setShowmsg(false);
    }
  };

  const handleorgnamechange = (e) => {
    setOrgname(e.target.value);
    if (showmsg) {
      setShowmsg(false);
    }
  };

  const handleplacechange = (e) => {
    setPlace(e.target.value);
    if (showmsg) {
      setShowmsg(false);
    }
  };

  const handlestatechange = (e) => {
    setState(e.target.value);
    if (showmsg) {
      setShowmsg(false);
    }
  };

  const handlecountrychange = (e) => {
    setCountry(e.target.value);
    if (showmsg) {
      setShowmsg(false);
    }
  };

  const handlepincodechange = (e) => {
    setPincode(e.target.value);
    if (showmsg) {
      setShowmsg(false);
    }
  };

  const handlelatitudechange = (e) => {
    setLatitude(e.target.value);
    if (showmsg) {
      setShowmsg(false);
    }
  };

  const handlelongitudechange = (e) => {
    setLongitude(e.target.value);
    if (showmsg) {
      setShowmsg(false);
    }
  };

  const handleweblinkchange = (e) => {
    setWeblink(e.target.value);
    if (showmsg) {
      setShowmsg(false);
    }
  };

  return (
    <div style={{ padding: "20px", overflow: "auto", height: "100%" }}>
      {showmsg && (
        <Typography
          style={{
            fontSize: "14px",
            color: msgcolor ? "var(--GreenBaseColor)" : "var(--RedBaseColor)",
            fontWeight: 500,
            marginBottom: "15px",
          }}
        >
          {" "}
          {msg}{" "}
        </Typography>
      )}
      <TextField
        id="Orgname"
        label={
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 500,
              color: "var(--PrimaryText)",
            }}
          >
            {" "}
            {props.data.orgdata.type === "Project"
              ? "Project Name"
              : "Organization Name"}
          </Typography>
        }
        variant="standard"
        InputProps={{
          startAdornment: <InputAdornment position="start"></InputAdornment>,
          style: {
            color: "var(--PrimaryText)",
          },
        }}
        sx={{
          width: "100%",
          marginBottom: "20px",
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "var(--PrimaryText)",
          },
          "& .MuiInput-underline:before": {
            borderBottomColor: "var(--PrimaryText)",
          },
          //'& .MuiInput-underline:after': { borderBottomColor: 'orange' },
        }}
        value={orgname}
        onChange={handleorgnamechange}
        disabled={props.data.request === "edit" ? true : false}
      />
      <TextField
        id="Place"
        label={
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 500,
              color: "var(--PrimaryText)",
            }}
          >
            {" "}
            Place{" "}
          </Typography>
        }
        variant="standard"
        InputProps={{
          startAdornment: <InputAdornment position="start"></InputAdornment>,
          style: {
            color: "var(--PrimaryText)",
          },
        }}
        sx={{
          width: "100%",
          marginBottom: "20px",
          "& .MuiInput-underline:before": {
            borderBottomColor: "var(--PrimaryText)",
          },
        }}
        value={place}
        onChange={handleplacechange}
      />
      <TextField
        id="State"
        label={
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 500,
              color: "var(--PrimaryText)",
            }}
          >
            {" "}
            State{" "}
          </Typography>
        }
        variant="standard"
        InputProps={{
          startAdornment: <InputAdornment position="start"></InputAdornment>,
          style: {
            color: "var(--PrimaryText)",
          },
        }}
        sx={{
          width: "100%",
          marginBottom: "20px",
          "& .MuiInput-underline:before": {
            borderBottomColor: "var(--PrimaryText)",
          },
        }}
        value={state}
        onChange={handlestatechange}
      />
      <TextField
        id="Country"
        label={
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 500,
              color: "var(--PrimaryText)",
            }}
          >
            {" "}
            Country{" "}
          </Typography>
        }
        variant="standard"
        InputProps={{
          startAdornment: <InputAdornment position="start"></InputAdornment>,
          style: {
            color: "var(--PrimaryText)",
          },
        }}
        sx={{
          width: "100%",
          marginBottom: "20px",
          "& .MuiInput-underline:before": {
            borderBottomColor: "var(--PrimaryText)",
          },
        }}
        value={country}
        onChange={handlecountrychange}
      />
      <TextField
        id="Pincode"
        label={
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 500,
              color: "var(--PrimaryText)",
            }}
          >
            {" "}
            Pincode{" "}
          </Typography>
        }
        variant="standard"
        InputProps={{
          startAdornment: <InputAdornment position="start"></InputAdornment>,
          style: {
            color: "var(--PrimaryText)",
          },
        }}
        sx={{
          width: "100%",
          marginBottom: "20px",
          "& .MuiInput-underline:before": {
            borderBottomColor: "var(--PrimaryText)",
          },
        }}
        value={pincode}
        onChange={handlepincodechange}
      />
      <TextField
        id="Latitude"
        label={
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 500,
              color: "var(--PrimaryText)",
            }}
          >
            {" "}
            Latitude{" "}
          </Typography>
        }
        variant="standard"
        InputProps={{
          startAdornment: <InputAdornment position="start"></InputAdornment>,
          style: {
            color: "var(--PrimaryText)",
          },
        }}
        sx={{
          width: "100%",
          marginBottom: "20px",
          "& .MuiInput-underline:before": {
            borderBottomColor: "var(--PrimaryText)",
          },
        }}
        value={latitude}
        onChange={handlelatitudechange}
      />
      <TextField
        id="Longitude"
        label={
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 500,
              color: "var(--PrimaryText)",
            }}
          >
            {" "}
            Longitude{" "}
          </Typography>
        }
        variant="standard"
        InputProps={{
          startAdornment: <InputAdornment position="start"></InputAdornment>,
          style: {
            color: "var(--PrimaryText)",
          },
        }}
        sx={{
          width: "100%",
          marginBottom: "20px",
          "& .MuiInput-underline:before": {
            borderBottomColor: "var(--PrimaryText)",
          },
        }}
        value={longitude}
        onChange={handlelongitudechange}
      />
      {props.data.orgdata.type === "Organization" && (
        <TextField
          id="WebLink"
          label={
            <Typography
              style={{
                fontSize: 20,
                fontWeight: 500,
                color: "var(--PrimaryText)",
              }}
            >
              {" "}
              Web Link{" "}
            </Typography>
          }
          variant="standard"
          InputProps={{
            startAdornment: <InputAdornment position="start"></InputAdornment>,
            style: {
              color: "var(--PrimaryText)",
            },
          }}
          sx={{
            width: "100%",
            marginBottom: "20px",
            "& .MuiInput-underline:before": {
              borderBottomColor: "var(--PrimaryText)",
            },
          }}
          value={weblink}
          onChange={handleweblinkchange}
        />
      )}
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Typography
          style={{ marginBottom: "10px", color: "var(--PrimaryText)" }}
        >
          {" "}
          Add Logo{" "}
        </Typography>
        <div style={{ display: "flex", gap: "50px", alignItems: "center" }}>
          <div
            style={{
              height: "100px",
              width: "100px",
              border: "2px solid",
              borderColor: "var(--LK_BrandBlue_1)",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundImage: `url(${backgroundimg})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              backgroundSize: `${imagewidth}px ${imageheight}px`,
            }}
          >
            <input
              style={{ display: "none" }}
              ref={inputFile}
              onChange={handleimageUpload}
              type="file"
              accept=".png,.PNG"
              multiple={false}
              //onDone={({base64}) => setListingData({ ...listingData, selectedFile: base64})}
            />
            {backgroundimg === "" ? (
              <AddIcon
                style={{
                  width: "40px",
                  height: "40px",
                  color: "var(--LK_BrandBlue_1)",
                  cursor: "pointer",
                }}
                onClick={handleaddlogoclick}
              />
            ) : (
              <AddIcon
                style={{
                  width: "40px",
                  height: "40px",
                  color: "transparent",
                  cursor: "pointer",
                }}
                onClick={handleaddlogoclick}
              />
            )}
          </div>
          <div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <TextField
                id="Height"
                label={
                  <Typography
                    style={{
                      fontSize: 20,
                      fontWeight: 500,
                      color: "var(--PrimaryText)",
                    }}
                  >
                    {" "}
                    Height{" "}
                  </Typography>
                }
                variant="standard"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start"></InputAdornment>
                  ),
                  style: {
                    color: "var(--PrimaryText)",
                  },
                }}
                sx={{
                  width: "80px",
                  marginBottom: "10px",
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "var(--PrimaryText)",
                  },
                }}
                value={imageheight}
                onChange={handlechangeheight}
              />
              <TextField
                id="Width"
                label={
                  <Typography
                    style={{
                      fontSize: 20,
                      fontWeight: 500,
                      color: "var(--PrimaryText)",
                    }}
                  >
                    {" "}
                    Width{" "}
                  </Typography>
                }
                variant="standard"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start"></InputAdornment>
                  ),
                  style: {
                    color: "var(--PrimaryText)",
                  },
                }}
                sx={{
                  width: "80px",
                  marginBottom: "20px",
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "var(--PrimaryText)",
                  },
                }}
                value={imagewidth}
                onChange={handlechangewidth}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
